module.exports = {
    PING                : "ping",
}